export interface ISelectionSortTrace {
    data: number[]
    comparedElements: [number, number]
    swappedElements: [number, number]
    sorted: boolean
}

export default class SelectionSortTracker {
    traces: [ISelectionSortTrace]

    constructor(data: number[]) {
        this.traces = [
            {
                data,
                comparedElements: [-1, -1],
                swappedElements: [-1, -1],
                sorted: false,
            },
        ]
    }

    trace(data: number[], comparedElements: [number, number], swappedElements: [number, number]): void {
        this.traces.push({
            data,
            comparedElements,
            swappedElements,
            sorted: false,
        })
    }

    traceCompare(data: number[], comparedElements: [number, number]): void {
        this.traces.push({
            data,
            comparedElements,
            swappedElements: [-1, -1],
            sorted: false,
        })
    }

    traceSwap(data: number[], swappedElements: [number, number]): void {
        this.traces.push({
            data,
            comparedElements: [-1, -1],
            swappedElements,
            sorted: false,
        })
    }

    trackSorted(data: number[]): void {
        this.traces.push({
            data,
            comparedElements: [-1, -1],
            swappedElements: [-1, -1],
            sorted: true,
        })
    }
}
